export default "__VITE_ASSET__CIf3PzMo__"